import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [navVisible, setNavVisible] = useState(true);
    const lastScrollY = useRef(0);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY <= 50) {
                // Always show navbar at the top (within 50px)
                setNavVisible(true);
            } else if (currentScrollY > lastScrollY.current) {
                // Scrolling DOWN — hide navbar
                setNavVisible(false);
                setMenuOpen(false); // close mobile menu when hiding
            } else {
                // Scrolling UP — show navbar
                setNavVisible(true);
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <nav className={`navbar ${navVisible ? 'navbar-visible' : 'navbar-hidden'}`}>
            <div className="navbar-container">
                <div className="navbar-logo">
                    <Link to="/" onClick={closeMenu}>
                        <img src="https://primerehab.ascentbw.com/Image/Logo.png" alt="Prime Rehab Logo" className="logo-img" />
                    </Link>
                </div>

                <div className="menu-icon" onClick={toggleMenu}>
                    {menuOpen ? (
                        // X Icon
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-close">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    ) : (
                        // Hamburger Icon
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-hamburger">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    )}
                </div>

                <div className={`navbar-right ${menuOpen ? 'active' : ''}`}>
                    <ul className="navbar-links">
                        <li><NavLink to="/" end onClick={closeMenu}>HOME</NavLink></li>
                        <li><NavLink to="/about" onClick={closeMenu}>ABOUT US</NavLink></li>
                        <li><NavLink to="/products" onClick={closeMenu}>PRODUCTS</NavLink></li>
                        <li><NavLink to="/services" onClick={closeMenu}>SERVICES</NavLink></li>
                        <li><NavLink to="/catalogue" onClick={closeMenu}>CATALOGUE</NavLink></li>
                        <li><NavLink to="/contact" onClick={closeMenu}>CONTACT</NavLink></li>
                    </ul>

                    <div className="navbar-action">
                        <button className="btn-primary" onClick={() => { closeMenu(); navigate('/contact#contact-form'); }}>ENQUIRE NOW</button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
